import shortid from "shortid";
import { formatDate } from "../../../../utils";
import { addDays } from "date-fns";
import {
  calcularTotal,
  calculaSubtotalParaChave,
  calculoDesconto,
  totalItensListaProduto,
  totalListaServicos,
  totalPagamentos,
} from "../add-orcamento-servico";
import { apiKeyDoCampo } from "../../../ordem-servicos/entities/campos-veiculo";

export class OrcamentoServico {
  numeroDocumento = null;
  serieDocumento = null;
  dataVencimento = null;
  clienteId = null;
  observacoes = "";
  observacoesChecklist = "";
  ativos = [];
  itens = [];
  servicos = [];
  pagamentos = null;
  acessorios = [];
  avarias = [];
  imagens = [];
  descontoProduto = 0;
  descontoProdutoPorcentagem = 0;
  descontoServico = 0;
  descontoServicoPorcentagem = 0;
  totalItens = 0;
  totalServicos = 0;
  totalPagamentos = 0;
  totalOrcamentoServico = 0;
  ativosCopiados = false;

  constructor(orcamento, id) {
    if (!orcamento) return;
    this.insertDadosOrcamentoServico(orcamento, id);
  }

  insertDadosOrcamentoServico(orcamento, id, isCopy) {
    this.ativosCopiados = !!isCopy;
    this.dataVencimento = orcamento.dataVencimento;
    this.status = isCopy ? "ABERTO" : orcamento.status;
    if (id) {
      this.createdAt = orcamento.createdAt;
      this.updatedAt = orcamento.updatedAt;
      this.insertUserId = orcamento.insertUserId;
      this.updateUserId = orcamento.updateUserId;
      this.numeroDocumento = orcamento.numeroDocumento;
      this.clienteId = orcamento.clienteId;
      this.observacoes = orcamento.observacoes || "";
      this.observacoesChecklist = orcamento.observacoesChecklist || "";
      this.descontoProduto = orcamento.itens?.length
        ? orcamento.itens.reduce((acc, curr) => acc + curr.desconto || 0, 0)
        : 0;
      this.descontoServico = orcamento.servicos?.length
        ? orcamento.servicos.reduce((acc, curr) => acc + curr.desconto || 0, 0)
        : 0;
      this.servicos =
        !isCopy && orcamento.servicos?.length
          ? orcamento.servicos.map((item) => new OrcamentoServicoServicos(item))
          : [];
      this.itens =
        !isCopy && orcamento.itens?.length
          ? orcamento.itens.map((item) => new OrcamentoServicoProdutos(item))
          : [];
      this.pagamentos =
        !isCopy && orcamento?.pagamentos?.length
          ? orcamento.pagamentos.map((pagamento) => new Pagamento(pagamento))
          : [];
      this.acessorios = Array.isArray(orcamento?.acessorios)
        ? orcamento.acessorios
        : [];
      this.avarias = Array.isArray(orcamento?.avarias) ? orcamento.avarias : [];
      this.imagens = Array.isArray(orcamento?.imagens)
        ? orcamento.imagens
            .map((imagem) => imagem?.url || imagem)
            .filter((imagemUrl) => !!imagemUrl)
        : [];
      if (orcamento.ativos && orcamento.ativos.length > 0) {
        this.ativos = orcamento.ativos.map((ativoRelacao) => {
          if (ativoRelacao.ativo) {
            const ativoComValores = {
              id: ativoRelacao.ativoId,
              nome: ativoRelacao.ativo.nome,
              permiteLancamentoManual:
                ativoRelacao.ativo.permiteLancamentoManual,
              camposPersonalizados:
                ativoRelacao.ativo.camposPersonalizados?.map((campo) => {
                  const valorSalvo = ativoRelacao.valoresCampos?.find(
                    (v) => v.campoPersonalizadoId === campo.id,
                  );
                  return {
                    ...campo,
                    value: valorSalvo?.valor || "",
                  };
                }) || [],
            };
            return new OrcamentoServicoAtivos(ativoComValores);
          }
          return {
            ativoId: ativoRelacao.ativoId,
            valoresCampos: ativoRelacao.valoresCampos || [],
          };
        });
      }
    }
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setHandleChangeDate(name, date) {
    this[name] = date != "Invalid Date" ? formatDate.toSend(date) : undefined;
  }

  setHandleChangeSwitch(name, checked) {
    this[name] = checked;
  }

  setHandleChangeAutoComplete(name, value) {
    this[name] = value ? value.id : null;
    if (name === "clienteId") {
      this.setIdentificarCliente(value);
    }
    if (name === "operacaoFiscalId") {
      this.setOperacaoFiscal(value);
    }
  }

  setIdentificarCliente(value) {
    this.clienteId = value?.id;
    this.clienteEmail = value?.email;
    this.clienteCnpjCpf = value?.cnpjCpf;
    this.clienteNome = value?.nomeRazaoSocial;
  }

  setAtivosComValoresSalvos(ativosDisponiveis, ativosSalvos) {
    this.ativos = ativosDisponiveis.map((ativoDisponivel) => {
      const ativoSalvo = ativosSalvos?.find(
        (a) =>
          a.ativoId === ativoDisponivel.id ||
          (a instanceof OrcamentoServicoAtivos &&
            a.ativoId === ativoDisponivel.id),
      );

      if (ativoSalvo) {
        if (ativoSalvo instanceof OrcamentoServicoAtivos) {
          return ativoSalvo;
        }

        const ativoComValores = {
          id: ativoDisponivel.id,
          nome: ativoDisponivel.nome,
          permiteLancamentoManual: ativoDisponivel.permiteLancamentoManual,
          camposPersonalizados:
            ativoDisponivel.camposPersonalizados
              ?.sort((a, b) => a.ordem - b.ordem)
              .map((campo) => {
                const valorSalvo = ativoSalvo.valoresCampos?.find(
                  (v) => v.campoPersonalizadoId === campo.id,
                );
                return {
                  ...campo,
                  value: valorSalvo?.valor || "",
                };
              }) || [],
        };
        return new OrcamentoServicoAtivos(ativoComValores);
      }

      return new OrcamentoServicoAtivos({
        id: ativoDisponivel.id,
        nome: ativoDisponivel.nome,
        permiteLancamentoManual: ativoDisponivel.permiteLancamentoManual,
        camposPersonalizados:
          ativoDisponivel.camposPersonalizados
            ?.sort((a, b) => a.ordem - b.ordem)
            .map((c) => ({
              ...c,
              value: "",
            })) || [],
      });
    });
  }

  setAtivos(ativosDisponiveis) {
    this.ativos = ativosDisponiveis.map(
      (ativo) =>
        new OrcamentoServicoAtivos({
          id: ativo.id,
          nome: ativo.nome,
          permiteLancamentoManual: ativo.permiteLancamentoManual,
          camposPersonalizados:
            ativo.camposPersonalizados
              ?.sort((a, b) => a.ordem - b.ordem)
              .map((c) => ({
                ...c,
                value: "",
              })) || [],
        }),
    );
  }

  setStatus(status) {
    this.status = status;
  }

  setStatusPersonalizado(statusPersonalizadoId) {
    this.statusPersonalizadoId = statusPersonalizadoId;
  }

  atualizarValorCampoAtivo(ativoId, campoPersonalizadoId, valor) {
    const ativo = this.ativos.find((a) => a.ativoId === ativoId);
    if (ativo) {
      ativo.atualizarValorCampo(campoPersonalizadoId, valor);
    }
  }

  preencherAtivoPorPlaca(ativoId, resposta) {
    const ativo = this.ativos.find((a) => a.ativoId === ativoId);
    if (!ativo || !resposta) return;
    const dados = {
      ...(resposta.basico?.dados || {}),
      chassi:
        resposta.chassi?.dados?.chassi ?? resposta.basico?.dados?.final_chassi,
    };
    ativo.camposPersonalizados.forEach((campo) => {
      const apiKey = apiKeyDoCampo(campo);
      if (apiKey && dados[apiKey] != null) {
        ativo.atualizarValorCampo(campo.id, dados[apiKey]);
      }
    });
  }

  setChangeServicos(servicos) {
    this.servicos = servicos?.length
      ? servicos.map((servico) => new OrcamentoServicoServicos(servico))
      : [];

    this.descontoServico = calculaSubtotalParaChave(servicos, "", "desconto");
    this.descontoServicoPorcentagem = calculoDesconto(
      servicos,
      this,
      "descontoServico",
      "descontoServicoPorcentagem",
      false,
    );

    this.totalServicos = totalListaServicos(servicos);
    const totalServicos = totalItensListaProduto(servicos || []);
    const totalProdutos = totalItensListaProduto(this.itens || []);
    this.totalOrcamentoServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }

  setEnderecoCliente(enderecoAlterado, enderecoCliente) {
    if (this.pessoaClienteId) {
      const endereco = enderecoAlterado || enderecoCliente;
      if (endereco) {
        this.orcamentoEnderecoCliente = {
          ...endereco,
          pessoaId: this.pessoaClienteId,
        };
        return;
      }
    }
    this.orcamentoEnderecoCliente = null;
  }

  setOperacaoFiscal(operacaoFiscal) {
    this.operacaoFiscalId = operacaoFiscal?.id;
    this.serieDocumento = operacaoFiscal?.serieDocumento;
    this.modeloDocumento = operacaoFiscal?.modeloDocumento;
  }

  setVendedorObrigatorioPermissao(permissao) {
    this.vendedorObrigatorio = permissao;
  }

  setConfiguracoes(configuracoes) {
    this.descontoItem = configuracoes?.descontoVendaItem;
    this.despesasItem = configuracoes?.despesaVendaItem;
    const dataVencimento = addDays(
      new Date(),
      configuracoes?.diasVencimentoOrcamento || 0,
    );
    this.dataVencimento = dataVencimento;
  }

  setChangeItens(produtos) {
    this.itens = produtos?.length
      ? produtos.map((produto) => new OrcamentoServicoProdutos(produto))
      : [];
    this.totalItens = totalItensListaProduto(produtos);
    this.descontoProduto = calculaSubtotalParaChave(produtos, "", "desconto");
    this.descontoProdutoPorcentagem = calculoDesconto(
      produtos,
      this,
      "descontoProduto",
      "descontoProdutoPorcentagem",
      false,
    );
    const totalServicos = totalItensListaProduto(this.servicos || []);
    const totalProdutos = totalItensListaProduto(produtos || []);
    this.totalOrcamentoServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }

  setChangePagamentos(pagamentos) {
    this.pagamentos = pagamentos?.length
      ? pagamentos.map((pagamento) => new Pagamento(pagamento))
      : [];
    this.totalPagamentos = totalPagamentos(pagamentos);
  }

  setChecklist(acessorios = [], avarias = []) {
    this.acessorios = (acessorios || []).filter(
      (acessorio) => acessorio?.contem,
    );
    this.avarias = avarias;
  }

  setImagens(imagens = []) {
    this.imagens = imagens;
  }

  initTotalPagamentos(pagamentos) {
    this.totalPagamentos = totalPagamentos(pagamentos || this.pagamentos);
    this.totalItens = totalItensListaProduto(this.itens || []);
    this.descontoProdutoPorcentagem =
      (this.descontoProduto / this.totalItens) * 100;
    this.totalServicos = totalListaServicos(this.servicos || []);
    this.descontoServicoPorcentagem =
      (this.descontoServico / this.totalServicos) * 100;
    const totalServicos = totalItensListaProduto(this.servicos || []);
    const totalProdutos = totalItensListaProduto(this.itens || []);
    this.totalOrcamentoServico =
      totalProdutos -
      (this.descontoProduto || 0) +
      (totalServicos - (this.descontoServico || 0));
  }
}

export class OrcamentoServicoAtivos {
  ativoId = null;
  nome = "";
  permiteLancamentoManual = false;
  valoresCampos = [];
  camposPersonalizados = [];

  constructor(ativo) {
    if (ativo) {
      this.ativoId = ativo.id;
      this.nome = ativo.nome;
      this.permiteLancamentoManual = !!ativo.permiteLancamentoManual;
      this.camposPersonalizados = ativo.camposPersonalizados || [];
      this.valoresCampos =
        ativo.camposPersonalizados?.map((campo) => ({
          campoPersonalizadoId: campo.id,
          valor: campo.value || "",
        })) || [];
    }
  }

  atualizarValorCampo(campoPersonalizadoId, valor) {
    const campoIndex = this.valoresCampos.findIndex(
      (campo) => campo.campoPersonalizadoId === campoPersonalizadoId,
    );

    if (campoIndex !== -1) {
      this.valoresCampos[campoIndex].valor = valor;
    } else {
      this.valoresCampos.push({
        campoPersonalizadoId,
        valor,
      });
    }
  }

  get camposParaRenderizar() {
    return this.camposPersonalizados.map((campo) => {
      const valorSalvo = this.valoresCampos.find(
        (v) => v.campoPersonalizadoId === campo.id,
      );
      return {
        ...campo,
        value: valorSalvo ? valorSalvo.valor : "",
      };
    });
  }
}

class OrcamentoServicoServicos {
  servicoId = null;
  prestadorServicoId = null;
  codigo = null;
  quantidade = 1;
  descricao = null;
  nome = null;
  desconto = null;
  totalItem = null;
  valor = null;
  classificacaoServicoNacional = null;
  codigoServicoNacional = null;
  aliquotaTotalSimplesNacional = null;

  constructor(item) {
    this.id = item.id ? item.id : shortid.generate();
    this.servicoId = item.servicoId;
    this.prestadorServicoId = item.prestadorServicoId;
    this.codigo = item.codigo;
    this.quantidade = item.quantidade;
    this.nome = item.nome;
    this.descricao = item.descricao;
    this.desconto = item.desconto;
    this.totalItem = item.quantidade * item.valor - (item.desconto || 0);
    this.valor = item.valor;
    this.classificacaoServicoNacional = item.classificacaoServicoNacional;
    this.codigoServicoNacional = item.codigoServicoNacional;
    this.aliquotaTotalSimplesNacional = item.aliquotaTotalSimplesNacional;
  }
}

class OrcamentoServicoProdutos {
  produtoId = null;
  descricao = null;
  unidade = null;
  quantidade = null;
  desconto = null;
  despesas = null;
  codigo = null;
  valorUnitario = null;
  ncm = null;
  tributosIcmsOrigem = null;
  origemKitId = null;
  referenciaKitId = null;
  precoCusto = null;
  ordemCompra = null;
  numeroItem = null;
  totalItem = null;
  vendedorId = null;
  insertUserId = null;
  updatedUserId = null;
  enderecoEstoqueId = null;
  produtosKit = null;

  constructor(item) {
    this.id = item.id ? item.id : shortid.generate();
    this.produtoId = item.produtoId;
    this.unidade = item.unidade;
    this.quantidade = item.quantidade;
    this.desconto = item.desconto;
    this.despesas = item.despesas;
    this.codigo = item.codigo;
    this.descricao = item.descricao;
    this.valorUnitario = item.valorUnitario;
    this.ncm = item.ncm;
    this.tributosIcmsOrigem = item.tributosIcmsOrigem;
    this.origemKitId = item.origemKitId;
    this.referenciaKitId = item.referenciaKitId;
    this.precoCusto = item.precoCusto;
    this.ordemCompra = item.ordemCompra;
    this.numeroItem = item.numeroItem;
    this.vendedorId = item.vendedorId;
    this.insertUserId = item.insertUserId;
    this.updatedUserId = item.updatedUserId;
    this.totalItem = calcularTotal(item);
    this.enderecoEstoqueId = item.enderecoEstoqueId;
    this.produtosKit = item.produtosKit;
  }

  setInputAttribute(name, value) {
    this[name] = value;
  }
}

class Pagamento {
  id = null;
  meioPagamentoId = null;
  condicaoPagamentoId = null;
  dataVencimento = null;
  valorTitulo = null;
  numeroTitulo = null;
  numeroAutorizacao = null;
  meioPagamentoSelecionado = null;

  constructor(pagamento) {
    this.id = pagamento.id ? pagamento.id : shortid.generate();
    this.meioPagamentoId = pagamento.meioPagamentoId;
    this.condicaoPagamentoId = pagamento.condicaoPagamentoId;
    this.dataVencimento = pagamento.dataVencimento;
    this.valorTitulo = pagamento.valorTitulo;
    this.numeroTitulo = pagamento.numeroTitulo;
    this.numeroAutorizacao = pagamento.numeroAutorizacao;
    this.meioPagamentoSelecionado = pagamento.meioPagamentoSelecionado;
  }
}
